import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const Principle = () => {
  return (
    <div className="flex justify-center">
      <div className="pt-[42px] w-[1920px]">
        <PageTitle title="全球应用加速原理" />
        <PageSubTitle title="光年无界全球企业办公应用加速服务支持定制化需求合作" />
        <img
          src="/imgs/saas/principle.png"
          alt="principle"
          className="w-[90%] object-contain h-[650px] mt-[80px] mx-[auto]"
        />
      </div>
    </div>
  );
};
